import React, { useState, useEffect } from 'react';
import { getDoc, doc, updateDoc,FieldPath  } from 'firebase/firestore';
import { db } from '../../../server/firebase';
import carga from '../../carga/carga';
import './permisos.css';

function Permisos() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const sections = [
    'DASHBOARD',
    'AGREGAR ESTUDIANTE',
    'MIS CURSOS',
    'FINANCIAMIENTO',
    'ESTUDIANTES',
    'INTERESADOS',
    'PERMISOS',
    'PROGRAMAS',
    'ICFES'
  ];

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    carga.mostrarCarga();
    setLoading(true);
    try {
      const roles = ['ADMINISTRADORES', 'ASESOR'];
      const allUsers = [];

      for (const role of roles) {
        const docRef = doc(db, 'ADMINISTRADORES', role);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          const data = docSnap.data();
          for (const email in data) {
            if (data[email]) {
              allUsers.push({
                email,
                role,
                name: data[email].name || email.split('@')[0],
                sectionsAccess: data[email].SECTIONSACCESS || []
              });
            }
          }
        }
      }
      setUsers(allUsers);
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      carga.ocultarCarga();
      setLoading(false);
    }
  };

  const handleSectionChange = (email, role, section, checked) => {
    setUsers(prevUsers =>
      prevUsers.map(user => {
        if (user.email === email && user.role === role) {
          const newSections = checked
            ? [...user.sectionsAccess, section]
            : user.sectionsAccess.filter(s => s !== section);
          return { ...user, sectionsAccess: newSections };
        }
        return user;
      })
    );
  };
  const savePermissions = async (user) => {
  carga.mostrarCarga();
  try {
    const docRef = doc(db, 'ADMINISTRADORES', user.role);

    await updateDoc(
      docRef,
      new FieldPath(user.email, 'SECTIONSACCESS'),
      user.sectionsAccess
    );

    alert('Permisos actualizados correctamente');
  } catch (error) {
    console.error('Error updating permissions:', error);
    alert('Error al actualizar permisos');
  } finally {
    carga.ocultarCarga();
  }
};

  

  if (loading) {
    return <div className="permisos-loading">Cargando usuarios...</div>;
  }

  return (
    <div className="permisos-container">
      <h2>Gestión de Permisos</h2>
      <div className="permisos-list">
        {users.map(user => (
          <div key={`${user.role}-${user.email}`} className="permisos-user-card">
            <div className="user-info">
              <h3>{user.name} ({user.role})</h3>
              <p>{user.email}</p>
            </div>
            <div className="sections-access">
              <h4>Secciones de Acceso:</h4>
              <div className="sections-checkboxes">
                {sections.map(section => {
                  const checkboxId = `cbx-${user.role}-${user.email}-${section}`;
                  return (
                    <div key={section} className="section-checkbox">
                      <div className="checkbox-wrapper-42">
                        <input
                          id={checkboxId}
                          type="checkbox"
                          checked={user.sectionsAccess.includes(section)}
                          onChange={(e) =>
                            handleSectionChange(user.email, user.role, section, e.target.checked)
                          }
                        />
                        <label className="cbx" htmlFor={checkboxId}></label>
                        <label className="lbl" htmlFor={checkboxId}>{section}</label>
                      </div>
                    </div>
                  );
                })}
              </div>
              <button className="save-btn" onClick={() => savePermissions(user)}>
                Guardar Cambios
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Permisos;